<!-- @format -->

<ng-container *transloco="let t">
  <fudis-heading [level]="headingLevel()" [variant]="'xl'">{{ t("TIMELINE.TIMING_SUB_HEADING") }}</fudis-heading>
  <fudis-grid [columns]="1" [width]="'xl'">
    <fudis-body-text [variant]="'lg-light'">
      {{ t("TIMELINE.TIMELINE_GUIDANCE") }}
      <fudis-icon-button
        class="timeline-guidance-info-circle"
        [ariaLabel]="t('ARIA_LABEL.SHOW_DETAILS')"
        [variant]="'tertiary'"
        [icon]="'info-circle-fill'"
        [size]="'extra-small'"
        [popoverText]="t('TIMELINE.TIMELINE_GUIDANCE_DETAILS')"
        [popoverPosition]="'above'" />
    </fudis-body-text>
  </fudis-grid>
  <fudis-grid [columns]="{ lg: 3 }" [width]="'initial'" [columnGap]="'sm'" [rowGap]="'sm'" [classes]="'fudis-mb-xl timeline-action-cards'">
    <fudis-grid-item [alignSelfY]="'stretch'" class="timeline-action-card timeline-action-card-aligned">
      <fudis-grid [columns]="1" [rowGap]="'sm'">
        <fudis-grid-item>
          <fudis-heading [level]="childHeadingLevel()" [variant]="'md'">{{ t("TIMELINE.TIMING_TEMPLATE_HEADING") }}</fudis-heading>
          <fudis-body-text [variant]="'md-light'">
            {{ t("TIMELINE.TIMING_TEMPLATE_GUIDANCE") }}
          </fudis-body-text>
        </fudis-grid-item>
        <fudis-grid-item>
          <fudis-button
            [label]="t('TIMELINE.INTRODUCE_TIMING_TEMPLATES')"
            [variant]="'primary'"
            [size]="'medium'"
            (handleClick)="openTimingTemplateModal()" />
        </fudis-grid-item>
        <fudis-grid-item>
          <fudis-button
            [label]="t('TIMELINE.TIMING_TEMPLATE.REMOVE_ALL_TIMINGS')"
            [variant]="'tertiary'"
            [icon]="'delete'"
            [size]="'medium'"
            (handleClick)="removeTimings()" />
        </fudis-grid-item>
      </fudis-grid>
    </fudis-grid-item>
    <fudis-grid-item [alignSelfY]="'stretch'" class="timeline-action-card timeline-action-card-aligned">
      <fudis-grid [columns]="1" [rowGap]="'sm'">
        <fudis-grid-item>
          <fudis-heading [level]="childHeadingLevel()" [variant]="'md'">{{ t("TIMELINE.UNTIMED_COURSE_UNIT_HEADING") }}</fudis-heading>
          <fudis-body-text [variant]="'md-light'">
            {{ t("TIMELINE.UNTIMED_COURSE_UNIT_GUIDANCE") }}
          </fudis-body-text>
        </fudis-grid-item>
        <fudis-grid-item>
          <fudis-button
            [label]="t('TIMELINE.TIME_COURSE_UNIT.OPEN_MODAL')"
            [variant]="'primary'"
            [size]="'medium'"
            (handleClick)="openTimeCourseUnitModal()" />
        </fudis-grid-item>
      </fudis-grid>
    </fudis-grid-item>
    <fudis-grid-item [alignSelfY]="'stretch'" class="timeline-action-card">
      <fieldset>
        <legend class="fudis-mb-none">
          <fudis-heading [level]="childHeadingLevel()" [variant]="'md'">{{ t("TIMELINE.MANAGE_TIMELINE_HEADING") }}</fudis-heading>
        </legend>
        <fudis-grid [columns]="1" [rowGap]="'sm'">
          <fudis-grid-item>
            <fudis-dl [tag]="'p'">
              <fudis-dl-item>
                <fudis-dt [contentText]="t('TIMELINE.VALIDITY_PERIOD_TITLE')" />
                @if (studyRightValidityPeriod$ | async | localDateRange; as validityPeriod) {
                  <fudis-dd [contentText]="validityPeriod" />
                } @else {
                  <fudis-dd class="fudis-text-emptystate" [contentText]="t('TIMELINE.NO_TIMELINE_STUDY_RIGHT')" />
                }
              </fudis-dl-item>
            </fudis-dl>
          </fudis-grid-item>
          <fudis-grid-item>
            <app-show-summer-period-checkbox />
          </fudis-grid-item>
          <fudis-grid-item>
            <app-show-past-study-terms-checkbox />
          </fudis-grid-item>
          <fudis-grid-item>
            <sis-checkbox
              [label]="t('TIMELINE.USE_HORIZONTAL_TIMELINE')"
              [checked]="useHorizontalLayout$ | async"
              (checkedChange)="setUseHorizontalLayout($event)" />
          </fudis-grid-item>
          <fudis-grid-item>
            <fudis-body-text [variant]="'md-regular'">
              {{ t("TIMELINE.TIMELINE_ZOOM") }}
              <fudis-icon-button
                class="timeline-guidance-info-circle"
                [ariaLabel]="t('ARIA_LABEL.SHOW_DETAILS')"
                [variant]="'tertiary'"
                [icon]="'info-circle-fill'"
                [size]="'extra-small'"
                [popoverText]="t('TIMELINE.TIMELINE_ZOOM_DETAILS')"
                [popoverPosition]="'above'" />
            </fudis-body-text>
          </fudis-grid-item>
        </fudis-grid>
      </fieldset>
    </fudis-grid-item>
  </fudis-grid>
  @if (studyTerms$ | async; as studyTerms) {
    @let isHorizontal = useHorizontalLayout$ | async;
    <div [class.timeline-full-width]="isHorizontal">
      <fudis-heading [id]="timelineHeadingId" [level]="childHeadingLevel()" [variant]="'xl'">{{
        t("TIMELINE.TIMELINE_HEADING")
      }}</fudis-heading>
      @if (isHorizontal) {
        <app-horizontal-timeline [labelledBy]="timelineHeadingId" [studyTermHeadingLevel]="grandChildHeadingLevel()" />
      } @else {
        <ul class="list-unstyled list-line-left">
          @for (term of studyTerms; track term.valid.startDate) {
            <li class="term-list-item list-line-marker">
              <app-timeline-study-term [term]="term" [headingLevel]="grandChildHeadingLevel()" />
            </li>
          }
        </ul>
      }
    </div>
  }
</ng-container>
